import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  status: void 0,
  Global: [],
  GlobalAll: [],
  selectedProjectId: null,
  accessibleProjects: [],
  globalLoadedAt: 0,
  globalAllLoadedAt: 0
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
